export const ApiDef_NoteTemplate = {
    _v1: {}
};
//# sourceMappingURL=api-def.js.map